import React from "react";
import VDMDashboardPIC from "components/app/vdmdashboard/pic/VDMDasboardPIC";


type ScreenVDMDashboardPICType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardPIC: React.FC<ScreenVDMDashboardPICType> = (
	props: ScreenVDMDashboardPICType
) => {
	return <VDMDashboardPIC vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardPIC;